import classNames from 'classnames';
// import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { getNid, WebUI } from "../../wui-core/src/index"
import DefaultEmptyImg from './defaultEmpty';
import { WithConfigConsumer } from "../../wui-provider/src/context";
import { getLangInfo } from "../../wui-locale/src/tool";
import i18n from './i18n';
import { EmptyProps } from './iEmpty';
import { prefix } from "../../wui-core/src/index";
import { isImageUrl } from "../../wui-core/src/utils/isImageUrl";

const defaultProps = {
    clsPrefix: "u-empty",
    image: <DefaultEmptyImg className={`${prefix}-empty-no-data`} />,
    description: undefined,
    locale: "zh-cn",
    imageStyle: {}
}

const EmptyComponent: React.FC<EmptyProps> = (props) => {
    const {
        clsPrefix,
        description,
        image,
        imageStyle,
        children,
        fieldid,
        className,
        locale
    } = props;

    const local = getLangInfo(locale, i18n, 'empty');

    const emptyClassMap = useMemo(() => {
        const langMap = local.langMap;
        return new Map([
            ["not-found", langMap.noFound],
            ["no-visualize-data", langMap.noDataImg],
            ["no-collect", langMap.noCollectImg],
            ["no-data", langMap.noDataImg],
            ["no-search", langMap.noSearchImg],
            ["no-network", langMap.noNetworkImg],
            ["no-data-easy", langMap.noDataImg],
        ]);
    }, [local.lang]);

    const imageNode = useMemo(() => {
        if (typeof image !== 'string') {
            return image;
        }

        const mappedText = emptyClassMap.get(image);
        const alt = typeof description === 'string' ? description : 'empty';

        // 如果有映射文本或者不是有效URL，使用DefaultEmptyImg
        if (mappedText || !isImageUrl(image)) {
            return (
                <DefaultEmptyImg
                    fieldid={fieldid ? `${fieldid}_${image}` : undefined}
                    className={`${clsPrefix}-${image}`}
                />
            );
        }

        // 否则使用img标签
        return (
            <img
                fieldid={fieldid ? `${fieldid}_empty_img` : undefined}
                alt={alt}
                src={image}
            />
        );
    }, [image, emptyClassMap, fieldid, clsPrefix, description]);

    const containerClassName = useMemo(
        () => classNames(
            `${clsPrefix}`,
            { [`${clsPrefix}-easy`]: image === 'no-data-easy' },
            className
        ),
        [clsPrefix, image, className]
    );

    const adapterNid = useMemo(() => getNid(props), [props]);

    return (
        <div
            role="emnpty"
            fieldid={fieldid ? `${fieldid}_empty` : undefined}
            className={containerClassName}
            {...adapterNid}
        >
            <div className={`${clsPrefix}-image`} style={imageStyle}>
                {imageNode}
            </div>
            {description !== "" && description !== null && (
                <div
                    fieldid={fieldid ? `${fieldid}_empty_data` : undefined}
                    className={`${clsPrefix}-description`}
                >
                    {description || emptyClassMap.get(image as string) || local.langMap.noDataImg}
                </div>
            )}
            {children && (
                <div
                    fieldid={fieldid ? `${fieldid}_empty_footer` : undefined}
                    className={`${clsPrefix}-footer`}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

const Empty = WithConfigConsumer()(WebUI({ name: "empty", defaultProps })(EmptyComponent));
// Empty.propTypes = propTypes;
export default Empty;
